import store from '@/store/index.js';
import axios from 'axios';

/**
 * API wrapper.
 */
class Api {
    /**
     * Call the ajax request.
     *
     * @param {string} initRequestType
     * @param {string} url
     * @param {object} data
     *
     * @return {Promise}
     */
    static call(initRequestType, url, data = null) {
        const currentCustomer = store.getters['user/currentCustomer'];

        if (axios.defaults) {
            axios.defaults.headers.common['Accept'] = 'application/json';
            axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

            if (currentCustomer) {
                axios.defaults.headers.common['X-Customer-Id'] = currentCustomer.id;
            } else {
                delete axios.defaults.headers.common['X-Customer-Id'];
            }

            // Allow sending and receiving cookies
            axios.defaults.withCredentials = true;
        }

        let requestType = initRequestType;

        let cleanData = data;

        if (process.env.VUE_APP_MOCK) {
            requestType = 'get';
        }

        return new Promise((resolve, reject) => {
            axios[requestType](url, cleanData)
                .then(response => {
                    resolve(response);
                })
                .catch(({ response }) => {
                    if (response && response.status === 401) {
                        store.dispatch('user/logout');
                    }

                    reject(response);
                });
        });
    }

    /**
     * Call the delete ajax request.
     *
     * @param {string} url
     * @param {object} data
     *
     * @return {Promise}
     */
    static delete(url, data = null) {
        return this.call('delete', url, data);
    }

    /**
     * Call the get ajax request.
     *
     * @param {string} url
     * @param {object} data
     *
     * @return {Promise}
     */
    static get(url, data = null) {
        return this.call('get', url, data);
    }

    /**
     * Call the post ajax request.
     *
     * @param {string} url
     * @param {object} data
     *
     * @return {Promise}
     */
    static post(url, data = null) {
        return this.call('post', url, data);
    }

    /**
     * Call the put ajax request.
     *
     * @param {string} url
     * @param {object} data
     *
     * @return {Promise}
     */
    static put(url, data = null) {
        return this.call('put', url, data);
    }

    /**
     * Call the patch ajax request.
     *
     * @param {string} url
     * @param {object} data
     *
     * @return {Promise}
     */
    static patch(url, data = null) {
        return this.call('patch', url, data);
    }
}

export default Api;
